import {useSyntheticUserQuery} from './useSyntheticUsersQuery';

// FNP-861: single-record read for the detail view. Read-only.
export const useSyntheticUser = (id: string) => {
    const query = useSyntheticUserQuery(id);

    return {
        record: query.data,
        loading: query.isLoading,
        isError: query.isError,
        notFound: query.isFetched && !query.data,
    };
};
